import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pcs-file-select',
  templateUrl: './file-select.component.html',
  styleUrls: ['./file-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileSelectComponent {
  @Input() disabled = false;
  @Input() fileSize: number;
  @Input() accepts: string[] = [];

  @Output() fileSelected = new EventEmitter<File>();
}
